import { makeAutoObservable } from 'mobx'
import type { IAlertProps } from 'shared/ui/Alert/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

export class TrialContactsLimitAlertStore {
  private _totalAmount = 0

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get trialSubscription() {
    return this._entities.subscriptionStore.trialSubscriptionStore
  }

  get loading() {
    return this.trialSubscription.loading
  }

  get totalAmount() {
    return this._totalAmount
  }

  setTotalAmount = (value: number) => {
    this._totalAmount = value
  }

  init = async () => {
    if (!this._entities.subscriptionStore.isTrial) return

    await this.trialSubscription.init()
  }

  get isCompleted() {
    return this.trialSubscription.isStatusCompleted
  }

  get configAlert(): IAlertProps {
    if (this.isAdminOrOwnerRole) {
      return {
        marginInline: 20,
        item: {
          type: 'warning',
          desc: this.isCompleted
            ? 'You have reached the limit of 250 contacts on Trial plan. Upgrade to remove the limits.'
            : 'You have reached the limit of 250 contacts on Trial plan. Get approved and upgrade to remove the limits.',
        },
        actions: [
          {
            type: 'primary',
            variant: 'navLink',
            text: this.isCompleted ? 'Upgrade' : 'Get approved',
            appType: this._entities.featureFlagsStore.billing_upgrade_v2 ? 'react' : 'vue',
            link: this.isCompleted
              ? `/${BillingPath.upgrade}`
              : '/settings/organization/compliance',
          },
        ],
      }
    }

    return {
      marginInline: 20,
      item: {
        type: 'warning',
        desc: this.isCompleted
          ? 'You have reached the limit of 250 contacts on Trial plan. To remove the limits, please ask one of your admins to upgrade.'
          : 'You have reached the limit of 250 contacts on Trial plan. To remove the limits, please ask one of your admins to get approved and upgrade.',
      },
    }
  }

  get isAdminOrOwnerRole() {
    return this._entities.usersStore.user?.isAdminOrOwnerRole
  }

  get hide() {
    if (this.loading) return true
    if (!this._totalAmount) return true
    if (!this._entities.subscriptionStore.isTrial) return true

    return this._totalAmount <= this._entities.subscriptionStore.trialActiveContactsCount
  }
}
